"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _material = require("@mui/material");

var _ButtonV = require("../../atoms/ButtonV2");

var _CustomIcon = require("../../atoms/CustomIcon");

var _jsxRuntime = require("react/jsx-runtime");

var Modal = function Modal(props) {
  var className = props.className,
      show = props.show,
      title = props.title,
      message = props.message,
      icon = props.icon,
      image = props.image,
      customComponent = props.customComponent,
      buttons = props.buttons,
      onClickModal = props.onClickModal,
      onClickBtnDefault = props.onClickBtnDefault;
  var icons = {
    error: _freeSolidSvgIcons.faClose,
    warning: _freeSolidSvgIcons.faExclamationTriangle,
    info: _freeSolidSvgIcons.faExclamation,
    success: _freeSolidSvgIcons.faCheck,
    successv2: _freeSolidSvgIcons.faCheck
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Backdrop, {
    open: show,
    className: "container-backgroundModal",
    timeout: 400,
    style: {
      backgroundColor: "transparent",
      zIndex: 10100
    },
    onClick: function onClick(event) {
      return onClickModal && onClickModal(event);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Fade, {
      in: show,
      timeout: 400,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerModal, {
        className: className ? className : "",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "contentModal",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("header", {
            children: ![null, undefined, ""].includes(title === null || title === void 0 ? void 0 : title.trim()) && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              className: "label-title",
              children: title.trim()
            })
          }), image && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: image,
            alt: "img modal"
          }), icons[icon === null || icon === void 0 ? void 0 : icon.toLowerCase()] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomIcon.CustomIcon, {
            type: "white",
            className: "iconModal " + "iconModal-" + icon.toLowerCase(),
            size: 35,
            borderType: "circle",
            icon: icons[icon.toLowerCase()]
          }), ![null, undefined, ""].includes(message === null || message === void 0 ? void 0 : message.trim()) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
            className: "label-message",
            children: [" ", message.trim(), " "]
          }), customComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container-customComponent",
            children: customComponent
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container-buttons",
            children: buttons !== null && buttons !== void 0 && buttons.length ? buttons : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
              type: "white",
              borderType: "oval",
              label: "Aceptar",
              size: 12,
              onClick: function onClick(event) {
                return onClickBtnDefault && onClickBtnDefault(event);
              }
            }, "btn-Aceptar")
          })]
        })
      })
    })
  });
};

exports.Modal = Modal;